import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const LeafIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9824 4.01813C14.4371 4.14966 10.6383 5.4866 8.55399 7.57087C6.47598 9.64888 6.28182 13.0878 7.12853 15.4573L8.49995 14.0858V11.5001C8.49995 10.9478 8.94766 10.5001 9.49995 10.5001C10.0522 10.5001 10.4999 10.9478 10.4999 11.5001V12.0859L12.4999 10.0859V7.50012C12.4999 6.94783 12.9476 6.50012 13.4999 6.50012C14.0522 6.50012 14.4999 6.94783 14.4999 7.50012V8.0859L16.2928 6.29302C16.6833 5.9025 17.3165 5.9025 17.707 6.29302C18.0975 6.68354 18.0975 7.3167 17.707 7.70722L15.9141 9.5001H16.4999C17.0522 9.5001 17.4999 9.94781 17.4999 10.5001C17.4999 11.0524 17.0522 11.5001 16.4999 11.5001H13.9141L11.9141 13.5001H12.4999C13.0522 13.5001 13.4999 13.9478 13.4999 14.5001C13.4999 15.0523 13.0522 15.5001 12.4999 15.5001H9.91416L8.6116 16.8026C10.9702 17.563 14.267 17.3201 16.283 15.3041C18.3482 13.239 19.8127 9.48194 19.9824 4.01813ZM7.06657 18.3476L3.70709 21.7071C3.31657 22.0976 2.68341 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L5.60253 16.9833C4.11683 13.9268 4.17428 9.12218 7.13979 6.15667C9.8033 3.49315 15.4148 1.98213 21.9998 2.00016C22.0179 8.58517 20.3607 14.0548 17.6972 16.7183C14.7943 19.6212 10.1292 19.7376 7.06657 18.3476Z"
            />
            <mask
                id="mask0_6029_9493"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="20"
                height="20"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.9824 4.01813C14.4371 4.14966 10.6383 5.4866 8.55399 7.57087C6.47598 9.64888 6.28182 13.0878 7.12853 15.4573L8.49995 14.0858V11.5001C8.49995 10.9478 8.94766 10.5001 9.49995 10.5001C10.0522 10.5001 10.4999 10.9478 10.4999 11.5001V12.0859L12.4999 10.0859V7.50011C12.4999 6.94783 12.9476 6.50012 13.4999 6.50012C14.0522 6.50012 14.4999 6.94783 14.4999 7.50011V8.0859L16.2928 6.29302C16.6833 5.9025 17.3165 5.9025 17.707 6.29302C18.0975 6.68354 18.0975 7.3167 17.707 7.70722L15.9141 9.5001H16.4999C17.0522 9.5001 17.4999 9.94781 17.4999 10.5001C17.4999 11.0524 17.0522 11.5001 16.4999 11.5001H13.9141L11.9141 13.5001H12.4999C13.0522 13.5001 13.4999 13.9478 13.4999 14.5001C13.4999 15.0523 13.0522 15.5 12.4999 15.5H9.91416L8.6116 16.8026C10.9702 17.563 14.267 17.3201 16.283 15.3041C18.3482 13.239 19.8127 9.48194 19.9824 4.01813ZM7.06657 18.3476L3.70709 21.7071C3.31657 22.0976 2.68341 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L5.60253 16.9833C4.11683 13.9268 4.17428 9.12218 7.13979 6.15667C9.8033 3.49315 15.4148 1.98213 21.9998 2.00016C22.0179 8.58517 20.3607 14.0548 17.6972 16.7183C14.7943 19.6212 10.1292 19.7376 7.06657 18.3476Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_6029_9493)">
                <rect width="24" height="24" className={fillStyles} />
            </g>
        </svg>
    );
};
